import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GlobalStyle } from './styles/GlobalStyles';
import HomePage from './pages/HomePage';
import FAQsPage from './pages/FAQsPage';
import ContactUsPage from './pages/ContactUsPage';
import Header from './components/Header';
// Remove default CRA CSS import if desired, as GlobalStyle handles base styles
// import './App.css';

function App() {
  return (
    <Router>
      <>
        <GlobalStyle />
        <Header />
        {/* Basic Navigation - consider moving to a dedicated Nav component */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
        </Routes>
      </>
    </Router>
  );
}

export default App;
